<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />
    <CropStatistics />
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'

import CropStatistics from '@/components/dashboard/CropStatistics.vue'

export default {
  name: 'ManagerGraphCrop',
  middleware: ['auth', 'manager'],
  components: {
    CropStatistics
  },
  metaInfo () {
    return {
      title: 'Crop Graph'
    }
  },
  mounted () {
    core.index()
  }
}
</script>
